import styled from "styled-components";
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Spin,
  Upload,
} from "antd";
import moment from "moment";
import { UploadOutlined } from "@ant-design/icons";
import { options } from "less";
import { useEffect, useState } from "react";
import { CALL_API } from "common/API";
import { display } from "@mui/system";
import axios from "axios";
import { getUserInfo, getChargeoutRatesList } from "redux/selectors";
import { useSelector } from "react-redux";

const StyledModal = styled(Modal)`
  .ant-modal-header {
    border-bottom: none;
    padding-top: 20px;
  }

  .ant-modal-title {
    font-weight: bold;
    font-weight: 1.2rem;
  }

  .ant-form-item-label {
    font-weight: 500;
  }

  .ant-modal-footer {
    border-top: none;
    padding-bottom: 20px;
  }

  .ant-modal-content {
    min-width: 800px;
    min-height: 220px;
  }

  .ant-picker {
    width: 100%;
  }
`;

const DescriptionModal = ({
  isModalOpen,
  setIsModalOpen,
  isEdit,
  setIsEdit,
  onSuccess,
  selectedRecord,
  employers,
}) => {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [btnLoader, setbtnLoader] = useState(false);
  const [isFileRemoved, setIsFileRemoved] = useState(false);
  const [isPdfModalOpen, setIsPdfModalOpen] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const userInfo = useSelector((state) => getUserInfo(state)) || {};
  const GradeandGradeCodes = useSelector((state) => getChargeoutRatesList(state)) || {};
  // const viewJobDescription = async () => {
  //   const token = window.localStorage.getItem("token") || "";
  //   if (!selectedRecord.jobDescriptionId || !selectedRecord.fileName) {
  //     message.error("Job description ID or file name is missing.");
  //     return;
  //   }
  //   try {
  //     setbtnLoader(true);
  //     const response = await axios.get(
  //       "https://15iwo8a004.execute-api.ap-south-1.amazonaws.com/Prod/appraisal/getdocument",
  //       {
  //         params: {
  //           jobdescriptionid: selectedRecord.jobDescriptionId,
  //           filename: selectedRecord.fileName,
  //         },
  //         headers: { Tymeplusjwt: token },
  //       }
  //     );
  //     if (response?.data?.status === "SUCCESS" && response?.data?.url) {
  //       setPdfUrl(response.data.url);
  //     } else {
  //       console.warn("Falling back to fileUrl");
  //       setPdfUrl(selectedRecord.fileUrl);
  //       setbtnLoader(false);
  //     }
  //   } catch (error) {
  //     console.error("API failed, falling back to fileUrl", error);
  //     setPdfUrl(selectedRecord.fileUrl);
  //     setbtnLoader(false);
  //   } finally {
  //     setIsPdfModalOpen(true);
  //     setbtnLoader(false);
  //   }
  // };

  const handleFilePreview = async () => {
    if (!selectedRecord?.jobDescriptionId || !selectedRecord?.fileName) {
      message.warning("Job description ID or file name is missing.");
      return;
    }

    const token = window.localStorage.getItem("token") || "";
    setbtnLoader(true);

    try {
      const response = await axios.get(
        "https://15iwo8a004.execute-api.ap-south-1.amazonaws.com/Prod/appraisal/getdocument",
        {
          params: {
            jobdescriptionid: selectedRecord.jobDescriptionId,
            filename: selectedRecord.fileName,
          },
          headers: { Tymeplusjwt: token },
        }
      );

      const finalUrl =
        response?.data?.status === "SUCCESS" && response?.data?.url
          ? response.data.url
          : selectedRecord.fileUrl;

      if (finalUrl) {
        window.open(finalUrl, "_blank"); // ✅ Open PDF in a new tab
      } else {
        message.error("File URL not found.");
      }
    } catch (error) {
      console.error("Error fetching document", error);
      if (selectedRecord.fileUrl) {
        window.open(selectedRecord.fileUrl, "_blank"); // fallback
      } else {
        message.error("Failed to fetch document.");
      }
    } finally {
      setbtnLoader(false);
    }
  };

  useEffect(() => {
    if (isEdit && selectedRecord) {
      const jobGradeCode =
        selectedRecord.jobGradeCode && selectedRecord.jobGrade
          ? `${selectedRecord.jobGradeCode} - ${selectedRecord.jobGrade}`
          : selectedRecord.jobGradeCode || "";

      form.setFieldsValue({
        jobgradecode: jobGradeCode,
        fileid: selectedRecord.fileId || "",
        fromdate: selectedRecord.fromDate
          ? moment(selectedRecord.fromDate, "DD-MM-YYYY")
          : null,
        todate: selectedRecord.toDate
          ? moment(selectedRecord.toDate, "DD-MM-YYYY")
          : null,
        filename: [
          {
            uid: "-1",
            name: selectedRecord.fileName,
            status: "done",
            url: selectedRecord.fileUrl,
          },
        ], // <-- Optional: to support validation if needed
      });

      // Delay to ensure Upload component picks it up
      setTimeout(() => {
        setFileList([
          {
            uid: "-1",
            name: selectedRecord.fileName,
            status: "done",
            url: selectedRecord.fileUrl,
          },
        ]);
      }, 0);
    }
  }, [isEdit, selectedRecord, form, isModalOpen]);

  const MAX_FILE_SIZE_MB = 10;

  const beforeUpload = (file) => {
    const isLt10M = file.size / 1024 / 1024 < MAX_FILE_SIZE_MB;
    if (!isLt10M) {
      message.error(`Upload only files up to ${MAX_FILE_SIZE_MB}MB`);
    }
    return isLt10M || Upload.LIST_IGNORE; // prevents file from being added to list
  };

  const handleUploadChange = ({ fileList: newFileList }) => {
    if (isEdit && newFileList.length === 0) {
      setIsFileRemoved(true);
    } else {
      setIsFileRemoved(false);
    }
    setFileList(newFileList);
  };
  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const postJobDescriptionData = async () => {
    try {
      const jobGradeCode = form.getFieldValue("jobgradecode");
      const fileId = form.getFieldValue("fileid");
      const fromDate = form.getFieldValue("fromdate");
      const toDate = form.getFieldValue("todate");
      const gradeObj = GradeandGradeCodes.find(
        (item) => isEdit ? `${item.code} - ${item.label}` : item.jobgradecode === jobGradeCode
      );

      const gradecode = gradeObj?.jobgradecode || "";
      const gradecodename = gradeObj?.jobgrade || "";

      let fileObj;
      let objectKey = "";
      let jobDescriptionId = null;

      if (isEdit && selectedRecord) {
        jobDescriptionId = selectedRecord.jobDescriptionId;
      }

      if (isEdit && selectedRecord && fileList.length > 0 && fileList[0].originFileObj) {
        fileObj = fileList[0].originFileObj;
      } else if (!isEdit && fileList.length > 0) {
        fileObj = fileList[0]?.originFileObj;
        if (!fileObj) {
          message.error("File not selected");
          return;
        }
      }

      if (fileObj) {
        const s3Payload = {
          method: "docupload",
          filename: fileObj.name,
          attachmenttype: "application/pdf",
          ...(isEdit && { docedit: true }),
        };

        const s3Url = isEdit ? `appraisal/jobdescription/jobgrade?jobgradecode=${selectedRecord.jobGradeCode}&jobdescriptionid=${selectedRecord.jobDescriptionId}` : `appraisal/jobdescription`;

        const s3Response = await CALL_API(s3Url, isEdit ? "patch" : "post", s3Payload);

        if (s3Response?.code !== "SUCCESS" || !s3Response?.url || !s3Response?.objectkey) {
          message.error("Failed to get upload URL");
          setbtnLoader(false);
          return;
        }

        const { url, objectkey, jobDescriptionid } = s3Response;
        objectKey = objectkey;
        if (!isEdit) {
          jobDescriptionId = jobDescriptionid;
        }

        const s3UploadResponse = await axios.put(url, fileObj, {
          headers: {
            "Content-Type": fileObj.type || "application/pdf",
          },
        });

        if (s3UploadResponse.status !== 200) {
          message.error("Failed to upload file to S3");
          setbtnLoader(false);
          return;
        }
      }

      const payload = {
        jobDescriptionid: jobDescriptionId || selectedRecord.jobDescriptionId,
        jobgradecode: gradecode || "",
        jobgrade: gradecodename || "",
        fileid: fileId || "",
        fromdate: fromDate ? moment(fromDate).format("DD-MM-YYYY") : "",
        todate: toDate ? moment(toDate).format("DD-MM-YYYY") : "",
        attachmenttype: "application/pdf",
        filename: fileList[0]?.name || selectedRecord?.fileName || "",
        updatedby: employers?.userid,
        employeeid: employers?.employeeid || "",
        employeename: employers?.fullname,
        ...(objectKey && { objectkey: objectKey }),
        ...(isEdit && fileObj && { docedit: true }),
      };

      let response;
      if (isEdit && selectedRecord) {
        const patchUrl = `appraisal/jobdescription/jobgrade?jobgradecode=${selectedRecord.jobGradeCode}&jobdescriptionid=${selectedRecord.jobDescriptionId}`;
        response = await CALL_API(patchUrl, "patch", payload);
      } else {
        payload.createdBy = userInfo?.userid;
        response = await CALL_API(`appraisal/jobdescription`, "post", payload);
      }

      if (response?.code === "SUCCESS") {
        setbtnLoader(false);
        message.success(isEdit ? "Job description updated successfully" : "Job description added successfully");
        form.resetFields();
        setFileList([]);
        if (typeof onSuccess === "function") {
          onSuccess();
        }
        setIsModalOpen(false);
        form.resetFields();
        setFileList([]);
      } else {
        message.error("Failed to add job description");
        setbtnLoader(false);
      }
    } catch (error) {
      console.error("[postJobDescriptionData] error -->", error);
      message.error("Something went wrong. Please try again.");
      form.resetFields();
      setFileList([]);
      setbtnLoader(false);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setIsEdit(false);
    form.resetFields();
    setFileList([]);
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setIsEdit(false);
    form.resetFields();
    setFileList([]);
  };

  const onFinish = async () => {
    setbtnLoader(true);
    await postJobDescriptionData();
    setIsModalOpen(false);
    setIsEdit(false);
  };

  const normFile = (e) => {
    if (Array.isArray(e)) return e;
    return e?.fileList;
  };

  const gradeOptions = GradeandGradeCodes?.map((item) => ({
    label: `${item.jobgradecode} - ${item.jobgrade}`,
    value: item.jobgradecode,
  }));
  return (
    <StyledModal
      title={isEdit ? "Editing" : "Adding JD"}
      open={isModalOpen}
      onCancel={handleClose}
      footer={null}
    >
      <Form
        form={form}
        name="jobdescriptionform"
        layout="vertical"
        autoComplete="off"
        onFinish={onFinish}
        initialValues={{
          jobgradecode: "",
          fileid: "",
          fromdate: null,
          todate: null,
        }}
      >
        <Row gutter={20}>
          {!isEdit && (
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                label="Job Grade & code"
                name="jobgradecode"
                rules={[
                  {
                    required: true,
                    message: "Please input your Job Grade & Code",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Search grade type"
                  name="grade"
                  options={gradeOptions}
                />
              </Form.Item>
            </Col>
          )}
          <Col xs={24} sm={24} md={12}>
            <Spin spinning={btnLoader} tip="Loading...">
              <Form.Item label="File Name" required>
                <Upload
                  name="file"
                  listType="text"
                  fileList={fileList}
                  onChange={handleUploadChange}
                  beforeUpload={(file) => {
                    const isPdf = file.type === "application/pdf";

                    if (!isPdf) {
                      message.error("Only PDF files are allowed");
                      return Upload.LIST_IGNORE;
                    }

                    // prevent auto upload
                    return false;
                  }}
                  maxCount={1}
                  accept=".pdf"
                  showUploadList={{
                    showRemoveIcon: true,
                    showDownloadIcon: true,
                  }}
                  onDownload={(file) => window.open(file.url)}
                  onPreview={handleFilePreview}
                >
                  {fileList?.length >= 1 ? null : (
                    <Button
                      icon={<UploadOutlined />}
                      style={{
                        backgroundColor: "#CFFAEA",
                        border: "none",
                        height: "35px",
                        fontWeight: "500",
                        width: "360px",
                      }}
                    >
                      Upload File
                    </Button>
                  )}
                </Upload>
                {/* <Modal
                  open={isPdfModalOpen}
                  onCancel={() => setIsPdfModalOpen(false)}
                  footer={null}
                  width={800}
                  style={{ top: 20 }}
                >
                  <iframe
                    src={pdfUrl}
                    title="PDF Preview"
                    width="100%"
                    height="600px"
                    frameBorder="0"
                  />
                </Modal> */}
              </Form.Item>
            </Spin>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label="File ID"
              name="fileid"
              rules={[
                { required: true, message: "Please Enter input File ID" },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12}>
            <Form.Item label="From Date" name="fromdate">
              <DatePicker
                disabledDate={(current) =>
                  current && current < moment().startOf("day")
                }
                format="DD-MM-YYYY"
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12}>
            <Form.Item label="To Date" name="todate">
              <DatePicker
                disabledDate={(current) =>
                  current && current < moment().startOf("day")
                }
                format="DD-MM-YYYY"
              />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            key="cancel"
            onClick={handleCancel}
            style={{ width: "130px", height: "34px", borderRadius: "8px" }}
          >
            Cancel
          </Button>
          ,
          {isEdit ? (
            <Button
              disabled={fileList.length === 0 && isFileRemoved}
              key="update"
              type="primary"
              htmlType="submit"
              loading={btnLoader}
              style={{
                width: "130px",
                height: "34px",
                borderRadius: "8px",
                marginLeft: "10px",
              }}
            >
              Update
            </Button>
          ) : (
            <Button
              disabled={fileList.length === 0}
              key="add"
              type="primary"
              htmlType="submit"
              loading={btnLoader}
              style={{
                width: "130px",
                height: "34px",
                borderRadius: "8px",
                marginLeft: "10px",
              }}
            >
              Add
            </Button>
          )}
        </Form.Item>
      </Form>
    </StyledModal>
  );
};

export default DescriptionModal;
